import router from '@/router/index.js'
import Settings from '@/classes/settings'
class FiltersHelper {
  constructor () {
    this.route = router.app.$route
    this.settings = new Settings()
  }

  getServerCallFilters (filters) {
    let data = {}
    for (let i = 0; i < filters.length; i++) {
      let filter = filters[i]
      if (this.route.query[filter.designator] == undefined) {
        continue
      }
      data[filter.designator] = this.route.query[filter.designator]
    }
    return data
  }

  isFilterOptionSelected (filter, option) {
    let url_filter_value = (this.route.query[filter.designator] || '').split(
      ','
    )
    return url_filter_value.includes(option.value + '')
  }
}

export default FiltersHelper
